import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";

import {
  COLOR_ADDITIONAL_VENETIAN_RED,
  COLOR_BLACK,
  COLOR_GREYSCALE_BLACK_75,
  COLOR_WHITE,
} from "~/theme/colors";
import { FontWeights } from "~/theme/typography";
import { getFormatMedia } from "~/theme/utils";
import { ARIAL_BLACK_FONT_FAMILY } from "~/theme/utils/font.constants";

import { SHOPPING_LIST_POPUP_CLASSES } from "./constants";

export const ShoppingListPopupContainer = styled(Dialog)(({ theme }) => {
  const formatMedia = getFormatMedia(theme);

  return {
    position: "fixed",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    zIndex: 99999,
    background: "rgba(0, 0, 0, 0.3)",
    [formatMedia.BREAKPOINT_TABLET]: {
      alignItems: "center",
    },
    "& .MuiDialog-paper": {
      margin: 0,
    },

    "& .MuiPaper-rounded": {
      borderRadius: 0,
    },

    "& .MuiDialog-scrollPaper": {
      alignItems: "flex-end",
      [formatMedia.BREAKPOINT_TABLET]: {
        alignItems: "center",
      },
    },
    [`& .${SHOPPING_LIST_POPUP_CLASSES.popup}`]: {
      maxWidth: "560px",
      width: "100%",
      padding: theme.spacing(4),
      background: COLOR_WHITE,
    },
    [`& .${SHOPPING_LIST_POPUP_CLASSES.popupTitleWrap}`]: {
      display: "flex",
      alignItems: "center",
      marginBottom: theme.spacing(2),
    },
    [`& .${SHOPPING_LIST_POPUP_CLASSES.title}`]: {
      ...theme.typography.h5,
      fontFamily: "Arial",
      letterSpacing: "0.01em",
      fontSize: "26px",
      fontWeight: FontWeights.fontWeightBold,
      color: COLOR_ADDITIONAL_VENETIAN_RED,
      marginLeft: theme.spacing(1.5),
    },
    [`& .${SHOPPING_LIST_POPUP_CLASSES.descriptionWrap}`]: {
      padding: 0,
    },
    [`& .${SHOPPING_LIST_POPUP_CLASSES.description}`]: {
      ...theme.typography.body1,
      fontFamily: "Arial",
      margin: 0,
      color: COLOR_BLACK,
    },
    [`& .${SHOPPING_LIST_POPUP_CLASSES.btnWrap}`]: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: theme.spacing(3),
      padding: "0",
    },
    [`& .${SHOPPING_LIST_POPUP_CLASSES.btn}`]: {
      ...theme.typography.button,
      fontFamily: ARIAL_BLACK_FONT_FAMILY,
      background: COLOR_BLACK,
      color: COLOR_WHITE,
      textTransform: "uppercase",
      fontSize: "16px",
      letterSpacing: "0.03em",
      borderRadius: "0",
      padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
      "&:hover": {
        background: COLOR_GREYSCALE_BLACK_75,
      },
    },
  };
});
